export default "__VITE_ASSET__OD3JyMGH__"